/* src/app/views/smart-filters/components/smart-filter-selection-group/smart-filter-selection-group.component.scss */
:host ::ng-deep .mat-expansion-panel-header {
  padding-left: 0;
  border-radius: 0;
  border-bottom: 1px solid #dadbde;
  transition: none !important;
}
:host ::ng-deep .mat-expansion-panel-header:hover {
  background-color: #ffffff !important;
}
:host ::ng-deep .mat-expansion-panel-body {
  padding: 0;
}
/*# sourceMappingURL=smart-filter-selection-group.component.css.map */
